import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { getFavouriteStations } from '../operations/getFavouriteStations';

import { STATUS_LOADING } from 'common/constants';

export const setFavouriteStations = (builder: ActionReducerMapBuilder<StationsState>) => builder
  .addCase(getFavouriteStations.pending, (state) => {
    state.favouriteStations.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getFavouriteStations.fulfilled, (state, { payload }) => {
    state.favouriteStations.loadingStatus = STATUS_LOADING.done;
    state.favouriteStations.data = payload.favouriteStations;
  })
  .addCase(getFavouriteStations.rejected, (state) => {
    state.favouriteStations.loadingStatus = STATUS_LOADING.error;
  });
